import { createAsyncThunk } from '@reduxjs/toolkit';

import { changeCompetition } from './change-competition';
import { setFilterItem, setNavItem, setNavReady } from '../init';

/**
 * Initialises the competition navigation with provided options.
 *
 * @param {object} options - Options for initializing the navigation.
 */
export const initialiseNav = createAsyncThunk(
    'nav/initialiseNav',
    async (options = {}, { dispatch }) => {
        setNavReady(false);
        const { initialValues, removeFinals, skipRound } = options;

        if (initialValues.competitionId === '*') {
            dispatch(
                setNavItem({
                    navItem: 'competition',
                    value: { id: '*' }
                })
            );
            return;
        }

        await dispatch(
            changeCompetition({
                competition: {
                    id: parseInt(initialValues.competitionId) || ''
                },
                ...(initialValues.seasonId && {
                    season: { id: parseInt(initialValues.seasonId) }
                }),
                ...(initialValues.roundId && {
                    round: { id: parseInt(initialValues.roundId) }
                }),
                removeFinals: removeFinals,
                skipRound: skipRound
            })
        );

        // Set initial filter values
        Object.keys(initialValues.filters || {}).forEach((filterKey) => {
            const value = initialValues.filters[filterKey];
            dispatch(setFilterItem({ filterItem: filterKey, value }));
        });

        // Set initial location
        if (initialValues.location) {
            dispatch(
                setNavItem({
                    navItem: 'location',
                    value: initialValues.location
                })
            );
        }
    }
);
